<template>
	<v-app-bar app color="#FFFFFF" class="rounded-b-xl pl-5 pr-5" elevate-on-scroll>
		<v-toolbar-title class="mb-1"><AppLogo /></v-toolbar-title>
		<v-spacer />
	</v-app-bar>
</template>
<script>
import AppLogo from '../widgets/AppLogo'

export default {
	components: { AppLogo },
	data: function () {
		return {
			idPedido: 0,
		}
	},
}
</script>